<template>
  <div class="disk-usage">
    <div class="progress">
      <div
        :class="premium && 'premium'"
        :style="{ right: progressBarOffset }"
        class="progress-bar"
      />
    </div>
    <div>
      <StorageInfoTextOnly v-if="isMobile" />
      <a
        :class="premium && 'premium'"
        :href="`${RoutePathOfDrive.PAYMENT}?refer_from=v_web_pikpak_ggong_sidebar_button\t`"
        class="flex-center go-pay"
        draggable="false"
        @click="$track.web_public_module_sidebar_click({ button: 'premium_page' })"
      >
        Premium
        <RightIcon
          :color="premium ? 'var(--color-premium)' : 'var(--color-primary)'"
          :size="18"
        />
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, toRefs } from '#imports'
import { useLayout } from '@/store/layout'
import { useUserInfo } from '@/store/userInfo'
import $track from '@/track/webYunpanPublicModule'
import { RoutePathOfDrive } from '@/types/enum'
import RightIcon from '~/components/icons/RightIcon.vue'
import StorageInfoTextOnly from '~/layouts/drive/StorageInfoTextOnly.vue'

const userInfo = useUserInfo()
const { isMobile } = toRefs(useLayout())
const { premium } = toRefs(userInfo)

const progressBarOffset = computed(() => {
  const percent = (userInfo.usage / userInfo.limit) * 100
  const filterPercent = Math.max(100 - Math.min(percent, 100), 0)
  return `${filterPercent.toFixed(4)}%`
})
</script>

<style lang="less" scoped>
@import 'assets/styles/util.less';

.disk-usage {
  font-size: 13px;

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.go-pay {
  text-decoration: none;
  line-height: 18px;
  height: 18px;
  font-weight: 700;
  color: var(--color-primary);

  &.premium {
    color: var(--color-premium);

    &:hover {
      color: var(--color-premium-hover);
    }
  }
}

.progress {
  position: relative;
  width: 100%;
  margin: 6px 0;
  height: 8px;
  border-radius: 2px;
  background: #c3c8cb;
  overflow: hidden;
}

.progress-bar {
  .progress;
  border-radius: 0;
  position: absolute;
  margin: 0;
  transition: width var(--transition-delay);
  background: var(--color-primary);

  &.premium {
    background: var(--color-premium);
  }
}
</style>
